/* eslint-disable no-null/no-null */
import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export class CustomValidators {
    static number(params: { min?: number; max?: number; isInteger?: boolean } = {}): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (
                !control.hasValidator(Validators.required)
                && (control.value === undefined || control.value === null || control.value === '')
            ) {
                return null;
            }

            const value = Number(control.value);

            if (isNaN(value)) {
                return { number: true };
            }

            const isRange = params.min !== undefined && params.max !== undefined;
            if (params.min !== undefined || params.max !== undefined) {
                const isTooSmall = params.min !== undefined && value < params.min;
                const isTooBig = params.max !== undefined && value > params.max;
                if (isRange && (isTooSmall || isTooBig)) {
                    return { numberRange: { min: params.min, max: params.max } };
                } else if (isTooSmall) {
                    return { numberMin: { min: params.min } };
                } else if (isTooBig) {
                    return { numberMax: { max: params.max } };
                }
            }

            if (params.isInteger && !Number.isInteger(value)) {
                return { numberInteger: true };
            }

            return null;
        };
    }
}
